import React from 'react';
import Cart from '../components/Cart';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const CartPage = () => {
    // Устанавливаем заголовок страницы
    useDocumentTitle('Корзина');
    
    return <Cart />;
};

export default CartPage;
